{
	"slTp": {
		"title": "Stop Loss / Take Profit",
		"price": "Price",
		"confirm": "Confirm",
		"stopLoss": "Stop Loss",
		"takeProfit": "Take Profit",
		"stopLossShort": "SL",
		"takeProfitShort": "TP",
		"positionsSuccessCreated": "Position successfully created!",
		"cantCreatePosition": "Couldn't create position.",
		"close": "Close",
		"positionSize": "Position size",
		"trailingStop": "Trailing Stop"
	}
}
